import * as React from 'react';
import { connect } from 'react-redux';

import { IUser } from '../../types/user';
import { LikesContent as LikesContentComponent } from '../../components/likes_content/likes_content';
import { loadLikeInfo, submitVote } from '../../reducers/modules/likes_content/likes_content';
import { TDispatch } from '../../types/redux';

interface IProps {
  disabled: boolean;
  type: string;
  objectID: string;
  user?: IUser;
  dispatch: TDispatch;
}

interface IContainerProps {
  disabled: boolean;
  type: string;
  objectID: string;
}

const LikesContentContainer: React.FC<IProps> = ({ disabled, type, objectID, user, dispatch }) => {
  const [likes, setLikes] = React.useState(0);
  const [dislikes, setDislikes] = React.useState(0);
  const [userLike, setUserLike] = React.useState(0);

  React.useEffect(() => {
    dispatch(loadLikeInfo(type, objectID, (data) => {
      setLikes(data.likesCount);
      setDislikes(data.dislikesCount);
      setUserLike(data.userLike);
    }, () => {
      setLikes(0);
      setDislikes(0);
      setUserLike(0);
    }) as never);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLikePressed = () => {
    dispatch(submitVote(type, objectID, 1, (newLikes, newDislikes) => {
      setLikes(newLikes);
      setDislikes(newDislikes);
      setUserLike(1);
    }, () => {}) as never);
  };

  const handleDislikePressed = () => {
    dispatch(submitVote(type, objectID, -1, (newLikes, newDislikes) => {
      setLikes(newLikes);
      setDislikes(newDislikes);
      setUserLike(-1);
    }, () => {}) as never);
  };

  return (
    <LikesContentComponent
      disabled={disabled}
      likesCount={likes}
      dislikesCount={dislikes}
      onLikePressed={handleLikePressed}
      onDislikePressed={handleDislikePressed}
      type={type}
      userLike={userLike}
      user={user}
    />
  );
};

export const LikesContent = connect<IContainerProps, {}, IContainerProps>(
  (state: { user: IUser }, props: IContainerProps) => ({
    user: state.user,
    disabled: props.disabled,
    type: props.type,
    objectID: props.objectID,
  }),
)(LikesContentContainer);
